module.exports = __webpack_public_path__ + "img/max-file-content-subtract.b817c9c3.svg";